import { extractBin8 } from '~/shared/lib/cardNumber';

import {
  CARD_NUMBER_HUMO,
  CARD_NUMBER_MIR,
  CARD_NUMBER_VIZA,
} from './constants';
import { emulateServer } from './emulateServer';
import { CardInfo } from './types';

export const mapCardInfoByBin: Record<string, CardInfo> = {
  [extractBin8(CARD_NUMBER_HUMO) as string]: {
    cardInfo: {
      brand: 'humo',
      cardNumberLength: 16,
      secureCodeLength: null,
    }
  },
  [extractBin8(CARD_NUMBER_MIR) as string]: {
    cardInfo: {
      brand: 'mir',
      cardNumberLength: 16,
      secureCodeLength: 3,
    }
  },
  [extractBin8(CARD_NUMBER_VIZA) as string]: {
    cardInfo: {
      brand: 'visa',
      cardNumberLength: 16,
      secureCodeLength: 3,
    }
  },
};

export const getCardInfo = emulateServer((bin: string) => {
  const cardInfo = mapCardInfoByBin[bin];

  if (!cardInfo) {
    throw new Error('Card is not supported');
  }

  return cardInfo;
});
